import React from 'react'
import { array, string, bool } from 'prop-types'

import CardGrid1 from './component/CardGrid1'
import CardGrid2 from './component/CardGrid2'
import CardGrid3 from './component/CardGrid3'
import CardGrid4 from './component/CardGrid4'
import CardGrid5 from './component/CardGrid5'
import CardGrid6 from './component/CardGrid6'
import CardGrid7 from './component/CardGrid7'
import CardGrid8 from './component/CardGrid8'
import CardGrid9 from './component/CardGrid9'
import CardGrid10 from './component/CardGrid10'
import CardGrid11 from './component/CardGrid11'
import CardGrid12 from './component/CardGrid12'
const variationMap = {
  '1': CardGrid1,
  '2': CardGrid2,
  '3': CardGrid3,
  '4': CardGrid4,
  '5': CardGrid5,
  '6': CardGrid6,
  '7': CardGrid7,
  '8': CardGrid8,
  '9': CardGrid9,
  '10': CardGrid10,
  '11': CardGrid11,
  '12': CardGrid12
}

const CardGrid = ({ articles, variation, displayCategory }) => {
  const CardGridVariation = variationMap[variation]

  return (
    <CardGridVariation articles={articles} displayCategory={displayCategory} />
  )
}

CardGrid.propTypes = {
  articles: array.isRequired,
  variation: string,
  displayCategory: bool
}

export default CardGrid
